export default __webpack_public_path__ + "static/media/tax-returns-gec-fof.e7af006f.png";